import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  visible: false,
  message: "",
  type: "info", // info | success | error | warning
  actions: [], // [{ label, link }]
  persistentKey: null, // for localStorage (like app banner)
};

const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      const { message, type, actions, persistentKey } = action.payload;

      // check localStorage if persistent
      if (persistentKey) {
        const dismissed = localStorage.getItem(persistentKey);
        if (dismissed) return;
      }

      state.visible = true;
      state.message = message;
      state.type = type || "info";
      state.actions = actions || [];
      state.persistentKey = persistentKey || null;
    },

    hideNotification: (state) => {
      if (state.persistentKey) {
        localStorage.setItem(state.persistentKey, "true");
      }
      state.visible = false;
    },
  },
});

export const { showNotification, hideNotification } = notificationSlice.actions;

export default notificationSlice.reducer;